import React from 'react';
type RingState = 'none' | 'unseen' | 'seen';
interface AvatarProps {
  src: string;
  name: string;
  size?: number;
  ring?: RingState;
  onClick?: () => void;
  label?: string;
}
const rings: Record<RingState, string> = {
  none: '',
  unseen: 'ring-2 ring-gold ring-offset-2 ring-offset-sand',
  seen: 'ring-1 ring-sand-line ring-offset-2 ring-offset-sand'
};
export function Avatar({
  src,
  name,
  size = 40,
  ring = 'none',
  onClick,
  label
}: AvatarProps) {
  const image = <img src={src} alt={onClick ? '' : name} aria-hidden={onClick ? 'true' : undefined} className={`shrink-0 rounded-pill object-cover ${rings[ring]} ${ring === 'seen' ? 'opacity-80' : ''}`} style={{
    width: size,
    height: size
  }} data-id="element-503" data-mp="bxu8xxoj7tik" />;
  if (!onClick) return image;
  return <button type="button" onClick={onClick} aria-label={label ?? name} className="shrink-0 rounded-pill transition-transform duration-150 ease-brand active:scale-[0.97]" data-id="element-504" data-mp="2ipljxz8jj1a0">
      {image}
    </button>;
}